import { useTranslation } from "react-i18next";

import { HookFormBaseDropdown } from "@/components_v2/FormFields/ReactHookForm/fields";
import FormFieldWrapper from "@/components_v2/Wrapper/FormFieldWrapper";
import { InviteTeamStepProps } from "../../types";

import "../../styles.css";

const InviteTeamStep = ({
  form,
  onOpenPermissionsModal,
}: InviteTeamStepProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-400">
      <div className="flex flex-col gap-200">
        <h2 className="register__title header-m-medium">
          {t("auth.labels.teamTitle")}
        </h2>
        <p className="register__description body-m-regular">
          {t("auth.labels.teamDescription")}
        </p>
        <button
          type="button"
          className="register__link body-m-regular"
          onClick={onOpenPermissionsModal}
        >
          {t("auth.labels.learnMoreAboutPermissions")}
        </button>
      </div>

      <div className="form-input-container text-start">
        <FormFieldWrapper label={t("auth.labels.emailAddresses")}>
          <HookFormBaseDropdown
            mode="tags"
            name="organization.invites"
            placeholder={t("auth.placeholders.enterEmailAndPressEnter")}
            open={false}
            options={[]}
            control={form.control}
          />
        </FormFieldWrapper>
      </div>
    </div>
  );
};

export default InviteTeamStep;
